module.exports = __webpack_public_path__ + "static/media/spinner.f3dcf768.svg";